
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/payment/whatsapp",
      function () {
        return require("private-next-pages/integrations/payment/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/payment/whatsapp"])
      });
    }
  